import '../../../schemas/common/email.js';
import { urlSchema } from '../../../schemas/common/url.js';
import '../../../schemas/common/phone.js';
import '../../../schemas/common/dateOfBirth.js';
import '../../../schemas/common/name.js';
import '../../../schemas/common/license.js';
import '../../../schemas/common/financial.js';
import '../../../schemas/common/checkbox.js';
import '../../../schemas/common/hours.js';
import '../../../schemas/common/tcpa.js';
import { z } from 'zod';
import { programOwnerServiceConfigSchema } from '../configurations/ProgramOwnerServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderProgramOwnerDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.PROGRAM_OWNER]: programOwnerServiceConfigSchema,
    }),
    analyticsBoardUrl: urlSchema,
});

export { servicesProviderProgramOwnerDataSchema };
//# sourceMappingURL=ServicesProviderProgramOwnerData.js.map
